import React, { useState } from "react";
import AirportAutocomplete from "../../AirportAutocomplete";
import { AUTOCOMPLETE_TYPE } from "../../../constants";
import { t } from "i18next";
import { Divider } from "../../../common/Divider";
import "./flight-segments.scss";

const FlightSegments = ({
  segments,
  handleBack,
  weekData,
  handleSegmentSelection,
  unSelectedSegmentsCount,
  setUnSelectedSegmentsCount,
  handleFlightSegmentsSearch,
  unSelectedSegments,
  exportScheduleToPdf,
}) => {
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);

  const handleSubmit = () => {
    console.log("handleSubmit");
    exportScheduleToPdf();
  };

  const handleSetError = (key, text) => { };

  const clearError = (key) => { };

  const draftCallback = () => { };

  return (
    <>
      <div className="flight-rotations-container flight-segments-container">
        <div className="fr-top-section">
          <div className="top-left">
            <div className="form-group common-autocomplete">
              <div className="p-float-label input-wrapper">
                <AirportAutocomplete
                  autoCompleteType={AUTOCOMPLETE_TYPE.ORIGIN}
                  selectedOrigin={selectedOrigin}
                  selectedDestination={selectedDestination}
                  setSelectedOrigin={setSelectedOrigin}
                  handleSetError={handleSetError}
                  clearError={clearError}
                  draftCallback={draftCallback}
                  screen="MANAGE_BOOKING"
                />
                <label htmlFor="destination-airport">{t("COMMON.ORG")}</label>
              </div>
            </div>
            <div className="form-group common-autocomplete">
              <div className="p-float-label input-wrapper">
                <AirportAutocomplete
                  autoCompleteType={AUTOCOMPLETE_TYPE.DESTINATION}
                  selectedOrigin={selectedOrigin}
                  selectedDestination={selectedDestination}
                  setSelectedDestination={setSelectedDestination}
                  handleSetError={handleSetError}
                  clearError={clearError}
                  draftCallback={draftCallback}
                  screen="MANAGE_BOOKING"
                />
                <label htmlFor="destination-airport">{t("COMMON.DEST")}</label>
              </div>
            </div>
            <div className="selected-week form-group">
              <label className="selected-week-label">
                {t("SCHEDULE_VISUALIZATION.SELECTED_WEEK")}:
              </label>
              <label className="week-label">
                {weekData
                  ? `${weekData.fromDate} to ${weekData.toDate}`
                  : "- -"}
              </label>
            </div>
          </div>
          <button
            className="primary-button"
            onClick={(e) =>
              handleFlightSegmentsSearch(selectedOrigin, selectedDestination)
            }
          >
            {t("COMMON.SEARCH")}
          </button>
        </div>
        <div className="fr-middle-section">
          <div className="common-list-table-scroll">
            <table class="common-list-table ">
              <tr className="table-header">
                <th className="header-cell">{t("COMMON.SELECT")}</th>
                <th className="header-cell">{t("COMMON.FLT_NO")}</th>
                <th className="header-cell">
                  {t("SCHEDULE_VISUALIZATION.FREQUENCY")}
                </th>
                <th className="header-cell">
                  {t("SCHEDULE_VISUALIZATION.DEPARTURE")}
                </th>
                <th className="header-cell">{t("CHOOSE_FLT.DEP_TIME")}</th>
                <th className="header-cell">
                  {t("SCHEDULE_VISUALIZATION.ARRIVAL")}
                </th>
                <th className="header-cell">{t("CHOOSE_FLT.ARR_TIME")}</th>
                <th className="header-cell">
                  {t("SCHEDULE_VISUALIZATION.VIA")}
                </th>
                <th className="header-cell">
                  {t("SCHEDULE_VISUALIZATION.AIRCRAFT")}
                </th>
              </tr>
              <Divider />
              <tbody className="table-body">
                {segments && segments.length !== 0 ? (
                  segments.map((segment, segmentIndex) => {
                    return (
                      <>
                        <label className="airport-name-header">
                          {segment.airportName} ({segment.airportCode})
                        </label>
                        {segment.outboundSegments &&
                          segment.outboundSegments.map((flight, index) => (
                            <tr
                              className={`body-row ${index === 0 || index % 2 === 0 ? "even" : ""
                                }`}
                              id={`segment-${flight.id}`}
                            >
                              <td className="body-cells">
                                <input
                                  id={`select-segment-outbound-${segmentIndex}--${flight.id}`}
                                  checked={flight.visible}
                                  value={flight.id}
                                  type="checkbox"
                                  name={`select-segment-outbound-${segmentIndex}--${flight.id}`}
                                  className="l-checkbox-only"
                                  onChange={(e) => {
                                    handleSegmentSelection(
                                      segmentIndex,
                                      index,
                                      "outbound",
                                      selectedOrigin,
                                      selectedDestination,
                                      e
                                    );
                                    if (e.target.checked) {
                                      setUnSelectedSegmentsCount(
                                        unSelectedSegmentsCount + 1
                                      );
                                    } else {
                                      setUnSelectedSegmentsCount(
                                        unSelectedSegmentsCount - 1
                                      );
                                    }
                                  }}
                                />
                              </td>
                              <td className="body-cells">
                                EY {flight.flightNumber}
                              </td>
                              <td className="body-cells gap-adjust">
                                {flight.frequency.split(" ").map((item, i) => {
                                  return (
                                    <span className="freq-day">{item}</span>
                                  );
                                })}
                              </td>
                              <td className="body-cells">
                                {flight.fromAirport}
                              </td>
                              <td className="body-cells">
                                {flight.departureTime}
                              </td>
                              <td className="body-cells">{flight.toAirport}</td>
                              <td className="body-cells">
                                {flight.arrivalTime}{" "}
                                {flight.arrivalDate ? flight.arrivalDate : ""}{" "}
                              </td>
                              <td className="body-cells">
                                {flight.viaAirport}
                              </td>
                              <td className="body-cells">
                                {flight.aircraftType}
                              </td>
                            </tr>
                          ))}
                        <>
                          {segment.inboundSegments &&
                            segment.inboundSegments.map((flight, index) => (
                              <tr
                                className={`body-row ${index === 0 || index % 2 === 0 ? "even" : ""
                                  }`}
                                id={`segment-${flight.id}`}
                              >
                                <td className="body-cells">
                                  <input
                                    id={`select-segment-inbound-${segmentIndex}--${flight.id}`}
                                    checked={flight.visible}
                                    value={flight.id}
                                    type="checkbox"
                                    name={`select-segment-inbound-${segmentIndex}--${flight.id}`}
                                    className="l-checkbox-only"
                                    onChange={(e) => {
                                      handleSegmentSelection(
                                        segmentIndex,
                                        index,
                                        "inbound",
                                        selectedOrigin,
                                        selectedDestination,
                                        e
                                      );
                                      if (e.target.checked) {
                                        setUnSelectedSegmentsCount(
                                          unSelectedSegmentsCount + 1
                                        );
                                      } else {
                                        setUnSelectedSegmentsCount(
                                          unSelectedSegmentsCount - 1
                                        );
                                      }
                                    }}
                                  />
                                </td>
                                <td className="body-cells">
                                  EY {flight.flightNumber}
                                </td>
                                <td className="body-cells gap-adjust ">
                                  {flight.frequency
                                    .split(" ")
                                    .map((item, i) => {
                                      return (
                                        <span className="freq-day">{item}</span>
                                      );
                                    })}
                                </td>
                                <td className="body-cells">
                                  {flight.fromAirport}
                                </td>
                                <td className="body-cells">
                                  {flight.departureTime}
                                </td>
                                <td className="body-cells">
                                  {flight.toAirport}
                                </td>
                                <td className="body-cells">
                                  {flight.arrivalTime}{" "}
                                  {flight.arrivalDate ? flight.arrivalDate : ""}
                                </td>
                                <td className="body-cells">
                                  {flight.viaAirport}
                                </td>
                                <td className="body-cells">
                                  {flight.aircraftType}
                                </td>
                              </tr>
                            ))}
                        </>
                      </>
                    );
                  })
                ) : (
                  <label className="no-data-avilable">
                    {t("PERMANENT_BOOKING.NO_DATA")}
                  </label>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="fr-bottom-section">
          <button className="secondary-button" onClick={handleBack}>
            {t("COMMON.BACK_BUTTON")}
          </button>
          <button className="primary-button" onClick={handleSubmit}>
            {t("SCHEDULE_VISUALIZATION.EXPORT")}
          </button>
        </div>
      </div>
    </>
  );
};

export default FlightSegments;
